import { Component } from "react";
import SimpleRenderer from "./SimpleRenderer";
import { numberWithSpaces } from "../../../../utilities/formaters";
import { getParts } from "./getParts";

import moment from "moment";
import PropTypes from "prop-types";

export default class PaymentsRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = { open: props.isOpen };
  }

  open = () => {
    this.setState({ open: true });
  };

  close = () => {
    this.setState({ open: false });
  };

  render() {
    const payment = this.props.payment;
    let total = 0;
    let list = [];
    total = getParts(payment[this.props.paymentKey], list);

    return (
      <div>
        <SimpleRenderer
          label={moment(payment[this.props.dateKey]).format("YYYY-MM-DD")}
        />
        Total amount: {numberWithSpaces(total, 2)} kr [
        {this.state.open ? (
          <span onClick={this.close} style={{ cursor: "pointer" }}>
            {" "}
            -{" "}
          </span>
        ) : (
          <span onClick={this.open} style={{ cursor: "pointer" }}>
            {" "}
            +{" "}
          </span>
        )}
        ]
        <br />
        {this.state.open
          ? list.map((item) => (
              // eslint-disable-next-line react/jsx-key
              <span>
                {item}
                <br />
              </span>
            ))
          : undefined}
        <br />
      </div>
    );
  }

  static propTypes = {
    payment: PropTypes.object,
    item: PropTypes.object,
    isOpen: PropTypes.bool,
    paymentKey: PropTypes.string,
    dateKey: PropTypes.string,
  };
}
